import { ReactElement } from 'react';

interface AccordionItemProps {
  children: ReactElement;
  header: ReactElement;
  speechBubbleMessage: string[];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AccordionItem = (props: AccordionItemProps) =>
  'AccordionItem ist nicht für die direkte Benutzung!';

export default AccordionItem;
